"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const entityRequest_1 = require("../entityRequest");
const queryBuilder_1 = __importDefault(require("../queryBuilder"));
const homes = (creds, Ienvironment, fetchExecutor) => ({
    byIds: (params) => (0, entityRequest_1.requestGet)(`v1/mobile_homes/${params.toString()}?detail_level=FULL`, creds, "MobileHome", Ienvironment, fetchExecutor),
    searchSummary: (params) => (0, entityRequest_1.requestGet)(`v1/mobile_homes/?${(0, queryBuilder_1.default)(Object.assign(Object.assign({}, params), { detailLevel: "SUMMARY" }))}`, creds, "MHBOListing", Ienvironment, fetchExecutor),
    searchSummaryV2: (params) => (0, entityRequest_1.requestGetSummary)(`v2/mobile_homes/?${(0, queryBuilder_1.default)(Object.assign(Object.assign({}, params), { detailLevel: "SUMMARY" }))}`, creds, Ienvironment, fetchExecutor),
});
exports.default = homes;
